import React, { Component, CSSProperties } from 'react';
import { Handles, Rail, Slider, Ticks, Tracks } from 'react-compound-slider';
import styled from 'styled-components';

import { Handle, SliderRail, Tick, Track } from './SliderSubcomponents';

const SliderContainer = styled.div`
  display: flex-wrap;
  flex-direction: column;
  align-self: center;
  width: 75%;
  margin: 24px;
`;
const SliderSubcontainer = styled.div`
  display: flex-wrap;
  flex-direction: column;
  align-self: center;
  height: 50px;
  width: 100%;
`;

interface IProps {
  min: number;
  max: number;
  values: readonly number[];
  unit: string;
  onChange: (lower: number, upper: number) => void;
}

interface IState {
  values: readonly number[];
  update: readonly number[];
  domain: number[];
}

const sliderStyle: CSSProperties = {
  position: 'relative',
  width: '100%'
};

class SliderComponent extends Component<IProps, IState> {

  state = {
    values: [this.props.values[0], this.props.values[1]],
    update: [this.props.min, this.props.max],
    domain: [this.props.min, this.props.max]
  };

  componentDidMount() {
    const { onChange, values } = this.props;

    onChange(values[0], values[1]);
  }

  onUpdate = (update: readonly number[]) => {
    this.setState({ update });
  }

  onChange = (values: readonly number[]) => {
    this.props.onChange(values[0], values[1]);
    this.setState({ values });
  }

  setRange = (min: number, max: number) => {
    const domain = [min, max];
    this.setState({ domain });
  }

  render() {
    const {
      state: { values },
    } = this;

    const { min, max, unit } = this.props;
    const tickCount = 10;
    const mode = 1;
    const step = 1;

    return (
      <SliderContainer>
        <SliderSubcontainer>
          <Slider
            mode={mode}
            step={step}
            domain={[min, max]}
            rootStyle={sliderStyle}
            onUpdate={this.onUpdate}
            onChange={this.onChange}
            values={values}
          >
            <Rail>
              {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
            </Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                  {handles.map((handle) => (
                    <Handle
                      key={handle.id}
                      handle={handle}
                      unit={unit}
                      domain={[min, max]}
                      getHandleProps={getHandleProps}
                    />
                  ))}
                </div>
              )}
            </Handles>
            <Tracks left={false} right={false}>
              {({ tracks, getTrackProps }) => (
                <div className="slider-tracks">
                  {tracks.map(({ id, source, target }) => (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      getTrackProps={getTrackProps}
                    />
                  ))}
                </div>
              )}
            </Tracks>
            <Ticks count={tickCount}>
              {({ ticks }) => (
                <div className="slider-ticks">
                  {ticks.map((tick) => (
                    <Tick key={tick.id} tick={tick} count={ticks.length} unit={unit} />
                  ))}
                </div>
              )}
            </Ticks>
          </Slider>
        </SliderSubcontainer>
      </SliderContainer>
    );
  }
}

export default SliderComponent;
